<template>
  <div>
    <div
      v-if="section"
      class="bg-white text-primary rounded-sm p-4 mb-4 shadow-md"
    >
      <div
        class="flex flex-row items-center text-sm font-medium text-primary mb-2"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="24"
          viewBox="0 0 24 24"
          width="24"
          class="w-4 h-4 mr-1 fill-current"
        >
          <path d="M0 0h24v24H0z" fill="none" />
          <path
            d="M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
          />
        </svg>
        <span class="text-primary text-opacity-70">Currently on:</span>
      </div>

      <div class="flex flex-row items-center leading-tight">
        <ImgixImage
          v-if="section.speaker && section.speaker.photo"
          :image="section.speaker.photo"
          :width="40"
          :height="40"
          class="lc-section-photo mr-2"
          :alt="section.speaker.name"
        />

        <div
          v-if="section.speaker && !section.speaker.photo"
          class="lc-section-initials"
        >
          {{ initials }}
        </div>

        <div class="flex flex-col">
          <div class="text-base text-primary font-bold leading-6 mb-1">
            {{ title }}
          </div>

          <span
            v-if="subtitle"
            class="text-xs font-medium text-primary  text-opacity-70"
          >
            {{ subtitle }}
          </span>
        </div>
      </div>

      <div
        v-if="next"
        class="mt-4 pt-2 text-xs border-0 border-t border-solid border-primary border-opacity-25"
      >
        <span class="text-primary text-opacity-50 font-medium">Coming up:</span>
        <span class="text-primary text-opacity-70 font-medium">
          {{ sectionTitle(next) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import ImgixImage from './ImgixImage';
import SectionMixin from '../mixins/section';
import isCurrent from '../helpers/is-current';
import orderBy from 'lodash/orderBy';

export default {
  components: { ImgixImage },
  mixins: [SectionMixin],

  props: {
    stream: Object,
    currentTime: Number
  },

  computed: {
    // The name of this computed is used by the SectionMixin
    section() {
      return this.sections.find((record) =>
        isCurrent(record, this.currentTime)
      );
    },

    next() {
      return this.sections[this.sections.indexOf(this.section) + 1];
    },

    sections() {
      return orderBy(this.stream.sections, 'position', 'asc');
    }
  }
};
</script>

<style></style>
